import React, { createContext, useContext, useEffect, useState } from "react";
import http from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        try {
            const { data } = await http.get("/auth/me");
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { refresh(); }, []);

    const login = async (email, password) => {
        const { data } = await http.post("/auth/login", { email, password });
        if (data?.token) localStorage.setItem("admin_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try { await http.post("/auth/logout"); } catch { /* ignore */ }
        localStorage.removeItem("admin_token");
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthCtx);
    if (!ctx) throw new Error("useAuth outside AuthProvider");
    return ctx;
}
